<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="showCloud" class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <button type="button" class="btn-close" @click="$emit('showModalModelBellacloud', false)"
              aria-label="Close" style="font-size: 25px;"></button>
          </div>

          <div class="modal-body p-2">
            <div class="row border-bottom pb-2">
              <div class="col-12 title">
                {{ translate.saveBellaCloud }}
              </div>
              <div class="col-12 sub-title">
                {{ translate.saveAlbumInfo }}
              </div>
            </div>
            <div class="row d-flex" v-if="isLoggedIn">
              <div class="row d-flex" v-if="list.data.length">
                <div v-for="album in list.data" class="col-lg-3 col-4 py-2 my-album text-center" :key="album.id"
                  @click="selectAlbum(album.id)">
                  <img v-if="album.photo_thumb.length" :src="album.photo_thumb[0]" :alt="album.name"
                    class="rounded-circle position-absolute z-1"
                    style="margin-top:40px;margin-left:18px;width:25px;height:25px;cursor:pointer" />
                  <font-awesome-icon v-else :icon="['fas', 'circle-check']"
                    style="position:absolute;z-index:1;margin-top:40px;margin-left:18px;width:25px;height:25px;color: #6ca727;cursor:pointer;background-color: white;" />

                  <font-awesome-icon :icon="['far', 'folder']" flip="horizontal"
                    style="color: #000000;font-size: 60px;cursor:pointer" />
                  <br>
                  <div class="title-album cursor-pointer">{{ album.name }}</div>
                </div>
              </div>  
              <div class="col-lg-3 col-4 py-2 my-album text-center" v-if="!video"
                  @click="selectFavoriteAlbum()">
                  <font-awesome-icon :icon="['fas', 'circle-check']"
                    style="position:absolute;z-index:1;margin-top:40px;margin-left:18px;width:25px;height:25px;color: #6ca727;cursor:pointer;background-color: white;" />

                  <font-awesome-icon :icon="['far', 'folder']" flip="horizontal"
                    style="color: #000000;font-size: 60px;cursor:pointer" />
                  <br>
                  <div class="title-album cursor-pointer">{{ locale == 'pt-br' ? 'Modelos Favoritas': 'Favorite models' }}</div>
                </div>
              <div class="text-center mt-3" v-if="loadingMyAlbum">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
              <div class="col-lg-6 col-6 d-flex align-items-center justify-content-center cursor-pointer"
                @click="newAlbum(true)">
                <div class="icon-new-album"></div>
                {{ locale == 'pt-br' ? 'Novo Album' : 'New album' }}
              </div>
            </div>
            <div class="row pt-3" v-else>
              <span>{{ translate.subTitle }}</span>
            </div>
            <vue-awesome-paginate class="mt-2" v-if="list.data" :modelValue="list.current_page"
            :total-items="list.total" :items-per-page="list.per_page" :max-pages-shown="3"
            :on-click="onClickHandlerMyAlbuns" />
          </div>
        </div>
        <ModalMessages @showModalMessages="showModalMessages" :options="options" />
        <ModalNewAlbumBellaCloud :show="modalNewAlbum" @showModalClose="newAlbum"
          @showModalMessages="showModalMessages" />
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia';
import { userStore } from '../../stores/user';
import tradutor from 'tradutors/bellacloud'
import { localeStore } from '../../stores/locale';
import api from '../../api';
import ModalNewAlbumBellaCloud from "components/Modais/ModalNewAlbumBellaCloud.vue"
import ModalMessages from '../../components/Modais/ModalMessages.vue'

export default defineComponent({
  name: 'ModalModelBellacloud',
  props: ['showCloud', 'imageIdSelected', "video"],
  emits: ['showModalModelBellacloud'],
  components: {
    ModalNewAlbumBellaCloud,
    ModalMessages
  },
  computed: {
    ...mapState(localeStore, ['locale']),
    ...mapState(userStore, ['isLoggedIn']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return tradutor.portugues
      } else {
        return tradutor.ingles
      }
    }
  },
  watch: {
    'showCloud': function () {
      if (this.isLoggedIn)
        this.getMyAlbums()
    }
  },
  data() {
    return {
      list: {
        current_page: 1,
        total: 1,
        per_page: 1,
        data: []
      },
      loadingMyAlbum: false,
      modalNewAlbum: false,
      options: {
        showModal: false,
        titleModal: '',
        textBodyModal: '',
        textButtonModal: ''
      },
    }
  },
  methods: {
    async getMyAlbums(page = '') {
      this.loadingMyAlbum = true
      api.get('v1/bellacloud/getMyAlbuns?page='+ page).then(({ data }) => {
        this.list = data
      })
        .finally(() => this.loadingMyAlbum = false)
    },
    async onClickHandlerMyAlbuns(page: number) {
      await this.getMyAlbums(page)
    },
    newAlbum(val) {
      this.modalNewAlbum = val

      if (!val)
        this.getMyAlbums()
    },
    async selectFavoriteAlbum(){
      let data = {
          photoId: this.imageIdSelected,
        }
        api.post('v1/bellacloud/favoriteModel', data).then(() => {
          this.showModalMessages({ message: { show: true, title: 'Sucesso', textBoby: this.translate.successBellaCloudPhoto, textButton: this.translate.btnClose } })
        }).catch(() => {
          this.showModalMessages({ message: { show: true, title: 'Error', textBoby: this.translate.errorBellaCloudPhoto, textButton: this.translate.btnClose } })
        })
    },
    showModalMessages(data) {
      this.options.showModal = data.message.show
      this.options.titleModal = data.message.title
      this.options.textBodyModal = data.message.textBoby
      this.options.textButtonModal = data.message.textButton
    },
    selectAlbum(id) {
      if (!this.video) {
        let data = {
          photoId: this.imageIdSelected,
          albumId: id
        }
        api.post('v1/bellacloud/addPhotoToAlbum', data).then(() => {
          this.showModalMessages({ message: { show: true, title: 'Sucesso', textBoby: this.translate.successBellaCloudPhoto, textButton: this.translate.btnClose } })
        }).catch(() => {
          this.showModalMessages({ message: { show: true, title: 'Error', textBoby: this.translate.errorBellaCloudPhoto, textButton: this.translate.btnClose } })
        })
      } else {
        let data = {
          partId: this.imageIdSelected,
          albumId: id
        }
        api.post('v1/bellacloud/addVideoPartToAlbums', data).then(() => {
          this.showModalMessages({ message: { show: true, title: 'Sucesso', textBoby: this.translate.successBellaCloudPhoto, textButton: this.translate.btnClose } })
        }).catch(() => {
          this.showModalMessages({ message: { show: true, title: 'Error', textBoby: this.translate.errorBellaCloudPhoto, textButton: this.translate.btnClose } })
        })
      }
    },
  }
})
</script>

<style scoped lang="css">
.icon-new-album {
  background-image: url('../../assets/img/icone-circulo-pontilhado-cruz-meio.svg');
  width: 54px;
  height: 54px;
  margin-inline-end: 15px;
}

.my-album {
  color: #444444;
}

.my-album>img {
  object-fit: fill;
}

.title {
  color: #b20000;
  font-weight: 600;
  text-align: center;
}

.sub-title {
  color: #aaaaaa;
  font-weight: 300;
  text-align: center;
  font-size: 12px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}

.modal-container {
  width: 40%;
  margin: auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  align-items: center;
  justify-content: end;
}

.modal-body {
  margin: 20px 0;
}

.vertical-w {
  width: 100%;
  object-fit: cover;
}

.horizontal-w {
  width: 100%;
}

.modal-footer {
  justify-content: center;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.title-album {
  font-size: 12px;
  padding-top: 10px;
}

.form-group input {
  padding: 10px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

.btn-outline-secondary {
  font-size: 15px;
  color: white;
  border-radius: 30px;
  background-color: black;
  border: none;
}

/* regras mobile 992vp */
@media screen and (max-width: 992px) {
  .modal-container {
    width: 90%;
  }
}
</style>